import { FC } from 'react';

type Props = {
  value?: string | null;
};

export const ActivityDescription: FC<Props> = ({ value }) => {
  return <>{value || <span className="text-gray-400">-</span>}</>;
};
